import clsx from 'clsx';
import { ICheckDontSaveChange, IFocusCell, IRangeSelectionProps, ISelectionProps } from './DataTable';
import styles from "./DataTable.module.css";
import Cell from './Cell';
interface IRowProps {
    selection?: ISelectionProps,
    row: any,
    focusedCell?: IFocusCell,
    rowIndex: number,
    checkDontSaveChange?: ICheckDontSaveChange,
    onFocuseCellChanged?: (data: IFocusCell) => void,
    selectedCells: any,
    rangeSelection?: IRangeSelectionProps,
    handleMouseDown: (rowIndex: number, colIndex: number) => void,
    handleMouseMove: (rowIndex: number, colIndex: number) => void,
}

const checkIfRowSelectedSingle = (rowId: any, selection?: ISelectionProps): boolean => {
    if (!selection || selection.mode !== "single") return false;
    if (selection.selectedRowKeys && selection.selectedRowKeys.length > 0 && selection.selectedRowKeys[0] === rowId) {
        return true;
    }
    return false;
};
const Row = (props: IRowProps) => {

    const { selection, row, rowIndex, selectedCells, handleMouseDown, handleMouseMove, onFocuseCellChanged } = props;
    const isRowSelectedSingle = checkIfRowSelectedSingle(row.original.id, selection);
    const isHaveFocusedCell = props.focusedCell && props.focusedCell.rowData.id === row.original.id;
    const handleRowClick = selection?.mode === "single"
        ? () => selection.onSelectionChanged?.([row.original.id])
        : undefined;
    return (
        <tr
            {...row.getRowProps()}
            onClick={handleRowClick}
            key={rowIndex}
        >
            {row.cells.map((cell: any, colIndex: number) => {

                return (
                    <Cell
                        cell={cell}
                        colIndex={colIndex}
                        handleMouseDown={handleMouseDown}
                        handleMouseMove={handleMouseMove}
                        isRowSelectedSingle={isRowSelectedSingle}
                        rowData={row.original}
                        rowId={row.original.id}
                        rowIndex={rowIndex}
                        selectedCells={selectedCells}
                        checkDontSaveChange={props.checkDontSaveChange}
                        focusedCell={props.focusedCell}
                        isHaveFocusedCell={isHaveFocusedCell}
                        key={`${row.original.id}-${colIndex}`}
                        onFocuseCellChanged={onFocuseCellChanged}
                        rangeSelection={props.rangeSelection}
                    />
                );
            })}
        </tr>
        // <tr
        //     {...row.getRowProps()}
        //     onClick={handleRowClick}
        //     key={rowIndex}
        // >
        //     {row.cells.map((cell: any, colIndex: number) => {
        //         let isDontSave: boolean = false;
        //         if (
        //             props.checkDontSaveChange &&
        //             cell.column.isAllowFocus
        //         ) {
        //             const rootRowData =
        //                 props.checkDontSaveChange.rootDataSource.find(
        //                     (x) => x.id === row.original.id
        //                 );
        //             if (rootRowData) {
        //                 const rootValue =
        //                     rootRowData[cell.column.dataField];
        //                 const currentValue =
        //                     row.original[cell.column.dataField];
        //                 if (rootValue !== currentValue) {
        //                     isDontSave = true;
        //                 }
        //             }
        //         }
        //         const cellStyle = {
        //             width: cell.column.width,
        //             minWidth: cell.column.minWidth,
        //             fontWeight: cell.column.isMainColumn ? "600" : 400,
        //             whiteSpace: "break-spaces" as const,
        //             textAlign: cell.column.align,
        //             ...(isSelectedSingle && { backgroundColor: "#fff8c5" }),
        //             ...(row.original.backgroundColor && { color: row.original.backgroundColor }),
        //         };
        //         const handleFocus = cell.column.isAllowFocus && onFocuseCellChanged
        //             ? () => onFocuseCellChanged({
        //                 rowData: row.original,
        //                 dataField: cell.column.dataField,
        //             })
        //             : undefined;
        //         return (
        //             <td
        //                 {...cell.getCellProps()}
        //                 key={colIndex}
        //                 style={cellStyle}
        //                 tabIndex={
        //                     cell.column.isAllowFocus ? 0 : undefined
        //                 }
        //                 onFocus={handleFocus}
        //                 className={clsx(
        //                     props.focusedCell && isHaveFocusedCell && props.focusedCell.dataField === cell.column.dataField
        //                         ? styles.focused
        //                         : "",
        //                     isDontSave ? styles.isDoneSave : "",
        //                     selectedCells.has(`${rowIndex}-${colIndex}`) ? styles.rangeSelected : ""
        //                 )}
        //                 onMouseDown={props.rangeSelection ? () => handleMouseDown(rowIndex, colIndex) : undefined}
        //                 onMouseMove={props.rangeSelection ? () => handleMouseMove(rowIndex, colIndex) : undefined}
        //             >
        //                 {cell.column.isHideZeroValue ?
        //                     <>
        //                         {row.original[cell.column.dataField]?.toString() === "0" ? "" : cell.render("Cell")}
        //                     </>
        //                     :
        //                     <>
        //                         {cell.column.cellRender
        //                             ? cell.column.cellRender(row.original)
        //                             : cell.render("Cell")}
        //                     </>
        //                 }


        //             </td>
        //         );
        //     })}
        // </tr>
    );
};
Row.displayName = 'Row';
export default Row;